/**
 * Returns a callback that increments the pagination index
 * for the current result type.
 * @param {Element} component
 * @returns {Function}
 */
const handleIndexIncrementation = (component) => () => {
    const typeIndex = $(component).data('typeIndex');
    const type = $(component).data('types')[typeIndex];
    const $results = $(component).find(`[data-${type}-results]`);
    const index = Number($results.attr('data-index') || 0);
    const offset = Number($results.attr('data-offset') || 1000);

    $results.attr('data-index', index + offset);
};

export default handleIndexIncrementation;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleIndexIncrementation.js